window.shasaStores = [
  {
    "name": "CDMX, PLAZA UNIVERSIDAD",
    "ciudad": "CDMX",
    "municipio": "Benito Juarez",
    "address": "Av. Universidad #1000",
    "addressTwo": "Col. Santa Cruz Atoyac",
    "estado": "CMX",
    "phone": "",
    "website": "shasa.com",
    "email": "",
    "storeCode": "T001",
    "zipCode": 3310,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "11:00 a 21:00",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.3670925217234,
    "lng": -99.1659731944738,
    "id": 2
  },
  {
    "name": "CDMX, SANTA FE",
    "ciudad": "CDMX",
    "municipio": "Cuajimalpa",
    "address": "Av. Vasco de Quiroga 3800",
    "addressTwo": "Col. Antigua Mina La Totolapa",
    "estado": "CMX",
    "phone": 5555707802,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T003",
    "zipCode": 5109,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.3609656547412,
    "lng": -99.2741284355788,
    "id": 3
  },
  {
    "name": "CDMX, GALERIAS INSURGENTES",
    "ciudad": "CDMX",
    "municipio": "Benito Juarez",
    "address": "Av. Insurgentes Sur 1352",
    "addressTwo": "Int. L-173 Col. Actipan",
    "estado": "CMX",
    "phone": 5556279103,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T004",
    "zipCode": 3230,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.3724493530738,
    "lng": -99.1786018992495,
    "id": 4
  },
  {
    "name": "CDMX, GALERIAS COAPA",
    "ciudad": "CDMX",
    "municipio": "Tlalpan",
    "address": "Av.Calz. Del Hueso 519 L117",
    "addressTwo": "Col. Residencial Acoxpa",
    "estado": "CMX",
    "phone": 5556794234,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T005",
    "zipCode": 14300,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.3022698251371,
    "lng": -99.1236328183988,
    "id": 5
  },
  {
    "name": "VILLAHERMOSA, GAL TABASCO 2000",
    "ciudad": "VILLAHERMOSA",
    "municipio": "Centro",
    "address": "Av. Prol. Paseo Tabasco 1405",
    "addressTwo": "Col. Galaxia-Tabasco 2000",
    "estado": "TAB",
    "phone": 9933169553,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T006",
    "zipCode": 86035,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 18.0009546305867,
    "lng": -92.9462394486736,
    "id": 6
  },
  {
    "name": "TLALNEPANTLA, MUNDO E",
    "ciudad": "TLALNEPANTLA",
    "municipio": "Tlanepantla de Baz",
    "address": "Blvd.Manuel Avila Camacho 1007",
    "addressTwo": "Col. San Lucas Tepetlacalco",
    "estado": "MEX",
    "phone": 5553614448,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T007",
    "zipCode": 54055,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.5258016478538,
    "lng": -99.2276143478509,
    "id": 7
  },
  {
    "name": "CANCÚN, LA ISLA",
    "ciudad": "CANCÚN",
    "municipio": "Benito Juarez",
    "address": "Blvd. Kukulkan #262 Int. LB-4",
    "addressTwo": "Zona Hotelera, Cancun Q Roo",
    "estado": "ROO",
    "phone": 9981768356,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T008",
    "zipCode": 77500,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 21.1111004559767,
    "lng": -86.7637096454634,
    "id": 8
  },
  {
    "name": "METEPEC, GALERIAS METEPEC",
    "ciudad": "METEPEC",
    "municipio": "Metepec",
    "address": "Blvrd Toluca Metepec Norte #400",
    "addressTwo": "Col. Coaxustenco, Metepec",
    "estado": "MEX",
    "phone": "",
    "website": "shasa.com",
    "email": "",
    "storeCode": "T009",
    "zipCode": 52140,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.2597301283739,
    "lng": -99.6208926705409,
    "id": 9
  },
  {
    "name": "MÉRIDA, LAS AMÉRICAS MÉRIDA",
    "ciudad": "MÉRIDA",
    "municipio": "Mérida",
    "address": "Calle 21 No 327 Int. 1,2,3 y 4",
    "addressTwo": "Col. Miguel Hidalgo",
    "estado": "YUC",
    "phone": 9999876399,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T011",
    "zipCode": 97229,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.9921490251402,
    "lng": -89.6493950349635,
    "id": 10
  },
  {
    "name": "MORELIA, LAS AMÉRICAS MORELIA",
    "ciudad": "MORELIA",
    "municipio": "Morelia",
    "address": "Av.Lic.Enrique Ramirez Miguel",
    "addressTwo": "Col. Las Americas",
    "estado": "MIC",
    "phone": 4433248320,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T012",
    "zipCode": 58270,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.6888854101414,
    "lng": -101.158120714112,
    "id": 11
  },
  {
    "name": "PUEBLA, ANGELOPOLIS",
    "ciudad": "PUEBLA",
    "municipio": "Puebla",
    "address": "Blvd. Del Nino Poblano 2510",
    "addressTwo": "Col. Concepcion La Cruz",
    "estado": "PUE",
    "phone": 2222254775,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T014",
    "zipCode": 72450,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.031848132049,
    "lng": -98.2327367934345,
    "id": 12
  },
  {
    "name": "PACHUCA, GALERÍAS PACHUCA",
    "ciudad": "PACHUCA",
    "municipio": "Pachuca de Soto",
    "address": "Camino Real de la Plata 100",
    "addressTwo": "Col. Zona Plateada Pachuca",
    "estado": "HID",
    "phone": 7711330003,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T015",
    "zipCode": 42083,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.098249843494,
    "lng": -98.7683574371683,
    "id": 13
  },
  {
    "name": "CDMX, PERISUR",
    "ciudad": "CDMX",
    "municipio": "Coyoacán",
    "address": "Av. Anillo Periferico Sur 4690",
    "addressTwo": "Col. Insurgentes Cuicuilco",
    "estado": "CMX",
    "phone": 5556068776,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T016",
    "zipCode": 4530,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.3039952338355,
    "lng": -99.1904682801345,
    "id": 14
  },
  {
    "name": "ORIZABA, PLAZA VALLE",
    "ciudad": "ORIZABA",
    "municipio": "Orizaba",
    "address": "Av. Circunvalacion Norte S/N",
    "addressTwo": "Col. Espinal",
    "estado": "VER",
    "phone": 2727217190,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T017",
    "zipCode": 94330,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 18.8631293512299,
    "lng": -97.0970320071529,
    "id": 15
  },
  {
    "name": "CHETUMAL,LAS AMÉRICAS CHETUMAL",
    "ciudad": "CHETUMAL",
    "municipio": "Othon P. Blanco",
    "address": "Av. Insurgentes KM 5.025",
    "addressTwo": "Chetumal",
    "estado": "ROO",
    "phone": 9838376133,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T018",
    "zipCode": 77084,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 18.5204888098823,
    "lng": -88.3231204389594,
    "id": 16
  },
  {
    "name": "QUERÉTARO, GALERIAS QUERETARO",
    "ciudad": "QUERÉTARO",
    "municipio": "Querétaro",
    "address": "Av. 5 Febrero Sur SN Loc. 221",
    "addressTwo": "Col. Los Virreyes",
    "estado": "QUE",
    "phone": 4422156428,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T019",
    "zipCode": 76175,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.5778526720538,
    "lng": -100.405956988347,
    "id": 17
  },
  {
    "name": "CULIACÁN, FORUM CULIACÁN",
    "ciudad": "CULIACÁN",
    "municipio": "Culiacán",
    "address": "Blvd. Jose Diego Valdez Rios",
    "addressTwo": "Col. Desarrollo Urbano",
    "estado": "SIN",
    "phone": 6677168799,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T022",
    "zipCode": 80020,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 24.8143852265017,
    "lng": -107.400607007389,
    "id": 18
  },
  {
    "name": "CANCÚN, CANCÚN MALL",
    "ciudad": "CANCÚN",
    "municipio": "Benito Juarez",
    "address": "Calle. Supermanzana 228 Mz. 22",
    "addressTwo": "Col. Zona Hotelera",
    "estado": "ROO",
    "phone": 9988926273,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T023",
    "zipCode": 77516,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 21.1828939949649,
    "lng": -86.8511312300735,
    "id": 19
  },
  {
    "name": "CUERNAVACA,GALERÍAS CUERNAVACA",
    "ciudad": "CUERNAVACA",
    "municipio": "Cuernavaca",
    "address": "Autop. Mex- Acapulco Km 87.85",
    "addressTwo": "Col. Ricardo Flores Magon",
    "estado": "MOR",
    "phone": 7773162438,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T024",
    "zipCode": 62370,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 18.9355998824974,
    "lng": -99.1925987128871,
    "id": 20
  },
  {
    "name": "CDMX, PARQUE DELTA",
    "ciudad": "CDMX",
    "municipio": "Benito Juarez",
    "address": "Av. Cuauhtemoc No. 462",
    "addressTwo": "Col. Narvarte",
    "estado": "CMX",
    "phone": 5554404068,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T025",
    "zipCode": 3020,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.4035385043849,
    "lng": -99.1537508413406,
    "id": 21
  },
  {
    "name": "ECATEPEC,LAS AMÉRICAS ECATEPEC",
    "ciudad": "ECATEPEC",
    "municipio": "Ecatepec",
    "address": "Av. Central SN Mz 4 Lt1-2",
    "addressTwo": "Col. Conj. Urbano Las Americas",
    "estado": "MEX",
    "phone": 5524864247,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T026",
    "zipCode": 55075,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.5836162764446,
    "lng": -99.0231650294478,
    "id": 22
  },
  {
    "name": "LERMA, LAS PLAZAS OUTLET",
    "ciudad": "LERMA",
    "municipio": "Lerma",
    "address": "Carr. Mexico-Toluca Km 50",
    "addressTwo": "Col. La Isla Lerma",
    "estado": "MEX",
    "phone": 7282845136,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T027",
    "zipCode": 52000,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.2828437281447,
    "lng": -99.5000293527567,
    "id": 23
  },
  {
    "name": "LOS CABOS, PUERTO PARAISO",
    "ciudad": "LOS CABOS",
    "municipio": "LOS CABOS",
    "address": "Lazaro Cardenas y Cabo Bello",
    "addressTwo": "Col. El Medano",
    "estado": "BCS",
    "phone": 6241433976,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T028",
    "zipCode": 23405,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 22.8876688811565,
    "lng": -109.909112017505,
    "id": 24
  },
  {
    "name": "XALAPA, LAS AMÉRICAS XALAPA",
    "ciudad": "XALAPA",
    "municipio": "Xalapa",
    "address": "Carr. Federal Xalapa Veracruz",
    "addressTwo": "Col. Pastoressa",
    "estado": "VER",
    "phone": 2288136127,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T029",
    "zipCode": 91193,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.3412128928567,
    "lng": -96.5091203786193,
    "id": 25
  },
  {
    "name": "CELAYA, GALERIAS CELAYA",
    "ciudad": "CELAYA",
    "municipio": "Celaya",
    "address": "Av. Nor-Oriente 200 Int. 216",
    "addressTwo": "Col. Compuertas del Campestre",
    "estado": "GUA",
    "phone": 4611594915,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T030",
    "zipCode": 38080,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.5316079430335,
    "lng": -100.779447735589,
    "id": 26
  },
  {
    "name": "CDMX, METRÓPOLI PATRIOTISMO",
    "ciudad": "CDMX",
    "municipio": "Benito Juarez",
    "address": "Avenida Patriotismo 229",
    "addressTwo": "Col. San Pedro de los Pinos",
    "estado": "CMX",
    "phone": 5555162161,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T031",
    "zipCode": 3800,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.3963724048845,
    "lng": -99.1806181457248,
    "id": 27
  },
  {
    "name": "COATZACOALCOS, FÓRUM CTZ",
    "ciudad": "COATZACOALCOS",
    "municipio": "Coatzacoalcos",
    "address": "Av. Universidad Km 8 Int. PB12",
    "addressTwo": "Carr. Antigua Minatitlan S/N",
    "estado": "VER",
    "phone": 9212109291,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T032",
    "zipCode": 96536,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 18.1421044314453,
    "lng": -94.4884552774104,
    "id": 28
  },
  {
    "name": "CANCÚN, GRAN PLAZA",
    "ciudad": "CANCÚN",
    "municipio": "Benito Juarez",
    "address": "Av. Nichupe Mza 18 LT-1-04",
    "addressTwo": "Col. Supermanzana 51",
    "estado": "ROO",
    "phone": 9988723353,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T033",
    "zipCode": 77533,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 21.1401896219118,
    "lng": -86.8542687797749,
    "id": 29
  },
  {
    "name": "PLAYA DEL CARMEN, CENTRO MAYA",
    "ciudad": "PLAYA DEL CARMEN",
    "municipio": "Solidaridad",
    "address": "Calle. 41 Sur No 2100 Lote 031",
    "addressTwo": "Col. Ejidal Playa del Carmen",
    "estado": "ROO",
    "phone": 9848039271,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T034",
    "zipCode": 77712,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.6187582456511,
    "lng": -87.0958543128673,
    "id": 30
  },
  {
    "name": "CDMX, PARQUE LINDAVISTA",
    "ciudad": "CDMX",
    "municipio": "Gustavo A. Madero",
    "address": "Colectores 13 No.280 L101-102",
    "addressTwo": "Col. Magdalena de las Salinas",
    "estado": "CMX",
    "phone": 5551199422,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T035",
    "zipCode": 7760,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.48591382269,
    "lng": -99.1315157974062,
    "id": 31
  },
  {
    "name": "IRAPUATO, PLAZA CIBELES",
    "ciudad": "IRAPUATO",
    "municipio": "Irapuato",
    "address": "Blvd a Villas de Irapuato 1443",
    "addressTwo": "Col. Ejido Irapuato",
    "estado": "GUA",
    "phone": 4626231403,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T036",
    "zipCode": 36643,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.6810034338767,
    "lng": -101.379659525626,
    "id": 32
  },
  {
    "name": "COLIMA, ZENTRALIA COLIMA",
    "ciudad": "COLIMA",
    "municipio": "Colima",
    "address": "Paseo Miguel de la Madrid 301",
    "addressTwo": "Col. Valle Dorado",
    "estado": "COL",
    "phone": 3123152428,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T037",
    "zipCode": 28018,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.2675529222924,
    "lng": -103.698030411285,
    "id": 33
  },
  {
    "name": "TEHUACÁN, PASEO TEHUACÁN",
    "ciudad": "TEHUACÁN",
    "municipio": "Tehuacán",
    "address": "Av. Adolfo Lopez Mateos 3800",
    "addressTwo": "Col. Sn Lorenzo Teotipilco",
    "estado": "PUE",
    "phone": 2383849641,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T038",
    "zipCode": 75855,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 18.4679065194201,
    "lng": -97.417879268934,
    "id": 34
  },
  {
    "name": "ECATEPEC, PLAZA ARAGÓN",
    "ciudad": "ECATEPEC",
    "municipio": "Ecatepec",
    "address": "Av.Carlos Hank Gonzalez 120",
    "addressTwo": "Col. Rinconada de Aragon",
    "estado": "MEX",
    "phone": 5522331961,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T039",
    "zipCode": 55140,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.5316748938568,
    "lng": -99.0263755241025,
    "id": 35
  },
  {
    "name": "NAUCALPAN, PLAZA SATÉLITE",
    "ciudad": "NAUCALPAN",
    "municipio": "Naucalpan",
    "address": "Calle Circuito C.C. No. 2251",
    "addressTwo": "Col. Ciudad Satelite",
    "estado": "MEX",
    "phone": 5551610792,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T040",
    "zipCode": 53100,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.5098141297276,
    "lng": -99.234576180801,
    "id": 36
  },
  {
    "name": "CELAYA, PARQUE CELAYA",
    "ciudad": "CELAYA",
    "municipio": "Celaya",
    "address": "Eje Nor Poniente No. 801",
    "addressTwo": "Col. 15 de Mayo",
    "estado": "GUA",
    "phone": 4611576210,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T041",
    "zipCode": 38020,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.5475639863454,
    "lng": -100.838121725268,
    "id": 37
  },
  {
    "name": "PLAYA DEL CARMEN, LAS AMERICAS",
    "ciudad": "PLAYA DEL CARMEN",
    "municipio": "Solidaridad",
    "address": "Carr. Federal Chetumal Km 291",
    "addressTwo": "Playa del Carmen",
    "estado": "ROO",
    "phone": 9841092539,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T042",
    "zipCode": 77710,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.6481714220597,
    "lng": -87.0817236527247,
    "id": 38
  },
  {
    "name": "CDMX, PARQUE TEZONTLE",
    "ciudad": "CDMX",
    "municipio": "Iztapalapa",
    "address": "Av. Canal de Tezontle No. 1512",
    "addressTwo": "Col. Dr. Alfonso Ortiz Tirado",
    "estado": "CMX",
    "phone": 5591290094,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T043",
    "zipCode": 9020,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.3842976654785,
    "lng": -99.0827648719505,
    "id": 39
  },
  {
    "name": "AGUASCALIENTES, ALTARIA",
    "ciudad": "AGUASCALIENTES",
    "municipio": "Aguascalientes",
    "address": "Blvd.a Zacatecas Norte No. 849",
    "addressTwo": "Col. Trojes de Alonso",
    "estado": "AGU",
    "phone": 4499932501,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T044",
    "zipCode": 20116,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 21.9236482867705,
    "lng": -102.28959774171,
    "id": 40
  },
  {
    "name": "MÉRIDA, GALERÍAS MÉRIDA",
    "ciudad": "MÉRIDA",
    "municipio": "Mérida",
    "address": "Calle 60 No. 299 X3 y 3A",
    "addressTwo": "Col. Revolucion",
    "estado": "YUC",
    "phone": 9999415797,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T045",
    "zipCode": 97110,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 21.0399973944705,
    "lng": -89.6314970000063,
    "id": 41
  },
  {
    "name": "PUERTO VALLARTA,GALERIAS VLL",
    "ciudad": "PUERTO VALLARTA",
    "municipio": "Puerto Vallarta",
    "address": "Blvd. Fco.Medina Ascencio 2920",
    "addressTwo": "Col. Educacion",
    "estado": "JAL",
    "phone": 3222210476,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T046",
    "zipCode": 48338,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.6578937655091,
    "lng": -105.239032430615,
    "id": 42
  },
  {
    "name": "DURANGO, PASEO DURANGO",
    "ciudad": "DURANGO",
    "municipio": "Durango",
    "address": "Av. Felipe Pescador No. 1401",
    "addressTwo": "Col. Esperanza",
    "estado": "DUR",
    "phone": 6181292009,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T047",
    "zipCode": 34080,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 24.0360727613064,
    "lng": -104.651021542331,
    "id": 43
  },
  {
    "name": "GUADALAJARA, GRAN PLAZA",
    "ciudad": "GUADALAJARA",
    "municipio": "Zapopan",
    "address": "Av.Vallarta No. 3959",
    "addressTwo": "Col. Don Bosco Vallarta",
    "estado": "JAL",
    "phone": 3336211437,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T048",
    "zipCode": 45049,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.673022555878624,
    "lng": -103.404328160132,
    "id": 44
  },
  {
    "name": "TUXTLA GTZ, PLAZA LAS AMÉRICAS",
    "ciudad": "TUXTLA GTZ",
    "municipio": "Tuxtla Gutierrez",
    "address": "Av.Quinta Nor Poniente 2651",
    "addressTwo": "Col. Tuxtla Gutierrez Centro",
    "estado": "CHP",
    "phone": 9611251855,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T049",
    "zipCode": 29030,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 16.7625138203189,
    "lng": -93.140038432099,
    "id": 45
  },
  {
    "name": "CDMX, PLAZA MADERO",
    "ciudad": "CDMX",
    "municipio": "Cuauhtemoc",
    "address": "Calle Francisco I Madero No.20",
    "addressTwo": "Col. Centro de la CDMX",
    "estado": "CMX",
    "phone": 5555212552,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T050",
    "zipCode": 6000,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.4340364112422,
    "lng": -99.1389049425976,
    "id": 46
  },
  {
    "name": "MÉRIDA, ALTABRISA MÉRIDA",
    "ciudad": "MÉRIDA",
    "municipio": "Mérida",
    "address": "Calle Siete No. 451 Int 13",
    "addressTwo": "Col. Fraccionamiento Altabrisa",
    "estado": "YUC",
    "phone": 9991679782,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T051",
    "zipCode": 97133,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 21.0164194310923,
    "lng": -89.5838690418798,
    "id": 47
  },
  {
    "name": "ACAPULCO, LA ISLA ACAPULCO",
    "ciudad": "ACAPULCO",
    "municipio": "Acapulco",
    "address": "Bvld. de las Naciones No.1813",
    "addressTwo": "Col. Playa diamente",
    "estado": "GRO",
    "phone": 7444621887,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T052",
    "zipCode": 39897,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 16.7733459374397,
    "lng": -99.7761534084972,
    "id": 48
  },
  {
    "name": "GUADALAJARA, GALERÍAS GDL",
    "ciudad": "GUADALAJARA",
    "municipio": "Zapopan",
    "address": "Av. Rafael Sanzio No.150",
    "addressTwo": "Col. Residencial La Estancia",
    "estado": "JAL",
    "phone": 3336822619,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T053",
    "zipCode": 45138,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.676766295442,
    "lng": -103.431155950314,
    "id": 49
  },
  {
    "name": "TEPIC, FORUM TEPIC",
    "ciudad": "TEPIC",
    "municipio": "Tepic",
    "address": "Blvd. Luis D. Colosio No. 680",
    "addressTwo": "Col. Benito Juarez",
    "estado": "NAY",
    "phone": 3112196523,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T054",
    "zipCode": 63175,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 21.4918373156861,
    "lng": -104.866960222962,
    "id": 50
  },
  {
    "name": "TORREÓN, GALERÍAS LAGUNA",
    "ciudad": "TORREÓN",
    "municipio": "Torreón",
    "address": "Av. Periferico Raul Lopez Schz",
    "addressTwo": "Col. El Fresno",
    "estado": "COA",
    "phone": 8717526702,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T055",
    "zipCode": 27018,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 25.5810015675067,
    "lng": -103.403841401225,
    "id": 51
  },
  {
    "name": "CHIHUAHUA, FASHION MALL CHIH",
    "ciudad": "CHIHUAHUA",
    "municipio": "CHIHUAHUA",
    "address": "Prfco de la Juventud 3501 L09",
    "addressTwo": "Col. Centro",
    "estado": "CHH",
    "phone": 6144303387,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T056",
    "zipCode": 31217,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 28.6226230382938,
    "lng": -106.114746949223,
    "id": 52
  },
  {
    "name": "NEZAHUALCOYOTL, CIUDAD JARDÍN",
    "ciudad": "NEZAHUALCOYOTL",
    "municipio": "Nezahualcóyotl",
    "address": "Av.Bordo Xochiaca Poligono 3",
    "addressTwo": "Col. Cd. Jardin Bicentenario",
    "estado": "MEX",
    "phone": 5515584119,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T057",
    "zipCode": 57205,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.425311886528,
    "lng": -99.0288366853789,
    "id": 53
  },
  {
    "name": "LOS MOCHIS, PASEO LOS MOCHIS",
    "ciudad": "LOS MOCHIS",
    "municipio": "Ahome",
    "address": "Blvd. Centenario 805 LB36-37",
    "addressTwo": "Col. Centro los Mochis",
    "estado": "SIN",
    "phone": 6688172091,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T058",
    "zipCode": 81200,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 25.7844676907836,
    "lng": -109.003820226998,
    "id": 54
  },
  {
    "name": "GUADALAJARA,OUTLET GUADALAJARA",
    "ciudad": "GUADALAJARA",
    "municipio": "Tlajomulco",
    "address": "Ctra.Gdl-Morelia Km12.5 L79",
    "addressTwo": "Tlajomulco Zuniga",
    "estado": "JAL",
    "phone": 3336864539,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T059",
    "zipCode": 45640,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.5226647635622,
    "lng": -103.483168217867,
    "id": 55
  },
  {
    "name": "ATIZAPÁN, GALERÍAS ATIZAPÁN",
    "ciudad": "ATIZAPÁN",
    "municipio": "Atizapán",
    "address": "Av.Ruiz Cortinez 255 Mza2 L529",
    "addressTwo": "Col. Lomas de Atizapan",
    "estado": "MEX",
    "phone": 5550772830,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T060",
    "zipCode": 52977,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.5491276820523,
    "lng": -99.2741446959973,
    "id": 56
  },
  {
    "name": "SALTILLO, GALERÍAS SALTILLO",
    "ciudad": "SALTILLO",
    "municipio": "Saltillo",
    "address": "Nazario S.Ortiz Garza2345 L163",
    "addressTwo": "Col. Tanque de pena Int",
    "estado": "COA",
    "phone": 8444850150,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T061",
    "zipCode": 25000,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 25.4573444871289,
    "lng": -100.980943112893,
    "id": 57
  },
  {
    "name": "CHILPANCINGO, GAL CHILPANCINGO",
    "ciudad": "CHILPANCINGO",
    "municipio": "Chilpancingo",
    "address": "Blvd.Rene Juarez C.130 L119",
    "addressTwo": "Col. Tepango",
    "estado": "GRO",
    "phone": 7474949167,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T063",
    "zipCode": 39095,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 17.5151838506394,
    "lng": -99.4847003754127,
    "id": 58
  },
  {
    "name": "CANCUN, MALECON AMERICAS",
    "ciudad": "CANCUN",
    "municipio": "Benito Juarez",
    "address": "Calle. SMza. 6 Mz1 lt1 L41-43A",
    "addressTwo": "Col. Supermanzana 6",
    "estado": "ROO",
    "phone": 9988875851,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T065",
    "zipCode": 77500,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 21.1472329526719,
    "lng": -86.8230311309232,
    "id": 59
  },
  {
     "name": "CDMX, PLAZA CENTRAL",
     "ciudad": "CDMX",
     "municipio": "Iztapalapa",
     "address": "Av.Canal del Rio Churubusco SN",
     "addressTwo": "Col. Central abasto",
     "estado": "CMX",
     "phone": 5556004021,
     "website": "shasa.com",
     "email": "",
     "storeCode": "T066",
     "zipCode": 9040,
     "extra3": "",
     "tags": "[\"tienda\"]",
     "monday": "",
     "modayA": "",
     "mondayC": "",
     "tuesday": "",
     "tuesdayA": "",
     "tuesdayC": "",
     "wednesday": "",
     "wednesdayA": "",
     "wednsayC": "",
     "thursday": "",
     "thursdayA": "",
     "thursdayC": "",
     "friday": "",
     "fridayA": "",
     "fridayC": "",
     "saturday": "",
     "saturdayA": "",
     "saturdayC": "",
     "sunday": "",
     "sundayA": "",
     "sundayC": "",
     "lat": 19.376576666735,
     "lng": -99.0955154659018,
     "id": 60
   },
  {
    "name": "TAPACHULA, GALERIAS TAPACHULA",
    "ciudad": "TAPACHULA",
    "municipio": "Tapachula",
    "address": "Carr.Tapachula-PtoMadero Km25",
    "addressTwo": "Col. Las Hortencias",
    "estado": "CHP",
    "phone": 9626284172,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T067",
    "zipCode": 30797,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 14.873335,
    "lng": -92.282638,
    "id": 61
  },
  {
    "name": "MONTERREY, PLAZA CUMBRES",
    "ciudad": "MONTERREY",
    "municipio": "Monterrey",
    "address": "Av. Hda. Penuelas 6771",
    "addressTwo": "Col. Cumbres Las Palmas",
    "estado": "NLE",
    "phone": 8110951774,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T068",
    "zipCode": 64349,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 25.7327081781213,
    "lng": -100.397662877175,
    "id": 62
  },
  {
    "name": "TEXCOCO, GRAN PATIO TEXCOCO",
    "ciudad": "TEXCOCO",
    "municipio": "Texcoco",
    "address": "Camino Molino Flores Palmar SN",
    "addressTwo": "Col. Sta Cruz de Arriba",
    "estado": "MEX",
    "phone": 5959540044,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T069",
    "zipCode": 56120,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.515949103963,
    "lng": -98.8669371707366,
    "id": 63
  },
  {
    "name": "ACAPULCO, GALERIAS DIANA",
    "ciudad": "ACAPULCO",
    "municipio": "Acapulco",
    "address": "Av.Costera Miguel Aleman 1926",
    "addressTwo": "Fracc. Magallanes",
    "estado": "GRO",
    "phone": 7444813288,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T070",
    "zipCode": 39670,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 16.860477548241,
    "lng": -99.8734350028412,
    "id": 64
  },
  {
    "name": "MONTERREY, GALERÍAS VALLE OTE",
    "ciudad": "MONTERREY",
    "municipio": "Monterrey",
    "address": "Av.Lazaro Cardenas 1000 L1173",
    "addressTwo": "Col. Valle del Mirador",
    "estado": "NLE",
    "phone": 8120865529,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T071",
    "zipCode": 64750,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 25.6382436473993,
    "lng": -100.314525507399,
    "id": 65
  },
  {
    "name": "TLAQUEPAQUE, FORUM TLAQUEPAQUE",
    "ciudad": "TLAQUEPAQUE",
    "municipio": "Guadalajara",
    "address": "Marcelino Garcia Barragan 2077",
    "addressTwo": "Col. Lomas del Paradero",
    "estado": "JAL",
    "phone": 3315781229,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T073",
    "zipCode": 44840,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.647321709469,
    "lng": -103.320083574428,
    "id": 66
  },
  {
    "name": "SAN LUIS POTOSI,PLAZA SAN LUIS",
    "ciudad": "SAN LUIS POTOSI",
    "municipio": "SAN LUIS POTOSI",
    "address": "Antonio Rocha Cordero 700 Int",
    "addressTwo": "Col. Lomas del Tec.",
    "estado": "SLP",
    "phone": 4448350384,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T074",
    "zipCode": 78215,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 22.1340031727228,
    "lng": -101.034350842131,
    "id": 67
  },
  {
    "name": "VILLAHERMOSA, ALTABRISA VSA",
    "ciudad": "VILLAHERMOSA",
    "municipio": "Villahermosa",
    "address": "Pfco.Carlos Pellicer Camara129",
    "addressTwo": "Col. 1o.de Mayo DUML",
    "estado": "TAB",
    "phone": 9932535195,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T075",
    "zipCode": 86190,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 17.9684832541704,
    "lng": -92.9267199004738,
    "id": 68
  },
  {
    "name": "CDMX, FORUM BUENAVISTA",
    "ciudad": "CDMX",
    "municipio": "Cuauhtemoc",
    "address": "Eje1 Nte Mosqueta 259 PB59",
    "addressTwo": "Col. Buenavista",
    "estado": "CMX",
    "phone": 5555415940,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T076",
    "zipCode": 6350,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.4497954331908,
    "lng": -99.1512938846589,
    "id": 69
  },
  {
    "name": "TUXTLA GTZ, PLAZA CRYSTAL",
    "ciudad": "TUXTLA GTZ",
    "municipio": "Chiapas",
    "address": "Blvd. Belisario Dgez Km 1081",
    "addressTwo": "Col. Jardines Tuxtla",
    "estado": "CHP",
    "phone": 9616716677,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T077",
    "zipCode": 29020,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 16.7537699629779,
    "lng": -93.1494275184022,
    "id": 70
  },
  {
    "name": "LA PAZ, PASEO LA PAZ",
    "ciudad": "LA PAZ",
    "municipio": "La Paz",
    "address": "Av. Agustin Olachea SN L67-68",
    "addressTwo": "Col. Campestre",
    "estado": "BCS",
    "phone": 6121665108,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T078",
    "zipCode": 23097,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 24.1148182706363,
    "lng": -110.340830698742,
    "id": 71
  },
  {
    "name": "ZACATECAS, GALERÍAS ZACATECAS",
    "ciudad": "ZACATECAS",
    "municipio": "Zacatecas",
    "address": "Blvd. El Bote No. 202 L130",
    "addressTwo": "Col. La Escondida",
    "estado": "ZAC",
    "phone": 4927681173,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T079",
    "zipCode": 98040,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 22.7772114956316,
    "lng": -102.597982606633,
    "id": 72
  },
  {
    "name": "VERACRUZ,LAS AMÉRICAS VERACRUZ",
    "ciudad": "VERACRUZ",
    "municipio": "Boca del Rio",
    "address": "Blvd. Adolfo Ruiz Cortines SN",
    "addressTwo": "Col. Costa Verde",
    "estado": "VER",
    "phone": 2291950015,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T080",
    "zipCode": 94298,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.1393961208842,
    "lng": -96.1066650760741,
    "id": 73
  },
  {
    "name": "VERACRUZ, EL DORADO",
    "ciudad": "VERACRUZ",
    "municipio": "Boca del Rio",
    "address": "Carr. Anton Lizardo No. 7A-8A",
    "addressTwo": "Col. El Estero",
    "estado": "VER",
    "phone": 2299861913,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T081",
    "zipCode": 94290,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.0955147781959,
    "lng": -96.1058199027078,
    "id": 74
  },
  {
    "name": "LEÓN, ALTACIA",
    "ciudad": "LEÓN",
    "municipio": "León",
    "address": "Blvd. Aeropuerto 104 L2034",
    "addressTwo": "Col. Cerrillo de Jerez",
    "estado": "GUA",
    "phone": 4777611191,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T082",
    "zipCode": 37530,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 21.0931338868361,
    "lng": -101.626266652758,
    "id": 75
  },
  {
    "name": "CAMPECHE, GALERÍAS CAMPECHE",
    "ciudad": "CAMPECHE",
    "municipio": "Campeche",
    "address": "Av. Pedro Sainz de Baranda SN",
    "addressTwo": "Col. AH Kim Pech",
    "estado": "CAM",
    "phone": 9816881418,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T083",
    "zipCode": 24014,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.8566215162039,
    "lng": -90.5226732495099,
    "id": 76
  },
  {
    "name": "CUATITLÁN IZCALLI, PERINORTE",
    "ciudad": "CUATITLÁN IZCALLI",
    "municipio": "Cuautitlán Izcalli",
    "address": "Hda.Sierra Vieja No.2 Int.272",
    "addressTwo": "Col. Hacienda de Parque",
    "estado": "MEX",
    "phone": 5558939488,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T084",
    "zipCode": 54769,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.6027862112138,
    "lng": -99.1910943078533,
    "id": 77
  },
  {
    "name": "MAZATLAN, GALERIAS MAZATLAN",
    "ciudad": "MAZATLAN",
    "municipio": "Mazatlan",
    "address": "AvDela Marina y AvDelfin 165",
    "addressTwo": "Col. Marina Mazatlan",
    "estado": "SIN",
    "phone": 6696880597,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T086",
    "zipCode": 82103,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 23.2783941563914,
    "lng": -106.448491921169,
    "id": 78
  },
  {
    "name": "SAN JUAN DEL RÍO, GAL SAN JUAN",
    "ciudad": "SAN JUAN DEL RÍO",
    "municipio": "San Juan del Rio",
    "address": "Carretera Panamericana Pte202",
    "addressTwo": "Col. Centro",
    "estado": "QUE",
    "phone": 4272724820,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T087",
    "zipCode": 76800,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.3866325295235,
    "lng": -100.011947933049,
    "id": 79
  },
  {
    "name": "MTY, PLAZA FIESTA SAN AGUSTÍN",
    "ciudad": "MTY",
    "municipio": "San Pedro Garza García",
    "address": "Av.Batallon San Patricio 1000",
    "addressTwo": "Col. Residencial San Agustín",
    "estado": "NLE",
    "phone": 8183632716,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T088",
    "zipCode": 66260,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 25.648853453741,
    "lng": -100.337073453985,
    "id": 80
  },
  {
    "name": "PUEBLA, GALERíAS SERDÁN",
    "ciudad": "PUEBLA",
    "municipio": "Puebla",
    "address": "Blvd.Hermanos Serdan270 Int123",
    "addressTwo": "Col. Rancho Posadas",
    "estado": "PUE",
    "phone": 2222242019,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T089",
    "zipCode": 72062,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.0715435387024,
    "lng": -98.2252940766876,
    "id": 81
  },
  {
    "name": "CDMX, VÍA VALLEJO",
    "ciudad": "CDMX",
    "municipio": "Azcapotzalco",
    "address": "Calzada Vallejo 1090 A110",
    "addressTwo": "Col. Industrial Vallejo",
    "estado": "CMX",
    "phone": 5591307058,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T090",
    "zipCode": 2300,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.4874547534343,
    "lng": -99.1525909281293,
    "id": 82
  },
  {
    "name": "CD.DEL CARMEN, ZENTRALIA CME",
    "ciudad": "CD.DEL CARMEN",
    "municipio": "Carmen",
    "address": "Av.Corregidora 26 Int.35",
    "addressTwo": "Col. Aeropuerto",
    "estado": "CAM",
    "phone": 9386885508,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T091",
    "zipCode": 24199,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 18.6543176272752,
    "lng": -91.807390952399,
    "id": 83
  },
  {
    "name": "TOLUCA, GALERÍAS TOLUCA",
    "ciudad": "TOLUCA",
    "municipio": "Toluca",
    "address": "Avenida Paseo Tollocan SN",
    "addressTwo": "Col. Santa Ana Tlapaltitlán",
    "estado": "MEX",
    "phone": 7222759980,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T092",
    "zipCode": 50160,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.2890665274784,
    "lng": -99.6228141838874,
    "id": 84
  },
  {
    "name": "TLALNEPANTLA, PLAZA TLALNE FM",
    "ciudad": "TLALNEPANTLA",
    "municipio": "Tlalnepantla de Baz",
    "address": "Av.Sor Juana Inés de Cruz 280",
    "addressTwo": "Col. San Lorenzo Ind.",
    "estado": "MEX",
    "phone": 5516656131,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T093",
    "zipCode": 54033,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.538330470746,
    "lng": -99.2060899381851,
    "id": 85
  },
  {
    "name": "HERMOSILLO, SONORA MALL",
    "ciudad": "HERMOSILLO",
    "municipio": "Hermosillo",
    "address": "Boulevard Cultura 55 Oriente",
    "addressTwo": "Col. Proyecto Rio Sonora",
    "estado": "SON",
    "phone": 6626887909,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T094",
    "zipCode": 83280,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 29.0661597041223,
    "lng": -110.950005448797,
    "id": 86
  },
  {
    "name": "CUAUTLA, PLAZA ATRIOS",
    "ciudad": "CUAUTLA",
    "municipio": "Cuautla",
    "address": "Camino Real Tetelcingo C.23",
    "addressTwo": "Col. Tierra Larga",
    "estado": "MOR",
    "phone": 7351312056,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T095",
    "zipCode": 62757,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 18.8681024451976,
    "lng": -98.9516249902094,
    "id": 87
  },
  {
    "name": "TLAXCALA, GALERÍAS TLAXCALA",
    "ciudad": "TLAXCALA",
    "municipio": "Tlaxcala",
    "address": "Av.Libramiento Pte Tlax.Km328",
    "addressTwo": "Sn.Sebastian Atlahapa",
    "estado": "TLA",
    "phone": 2466881780,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T096",
    "zipCode": 90111,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.290651111917,
    "lng": -98.2296086150474,
    "id": 88
  },
  {
    "name": "NAUCALPAN, PARQUE TOREO",
    "ciudad": "NAUCALPAN",
    "municipio": "Naucalpan",
    "address": "Blvd.Manuel Avila Camacho No.5",
    "addressTwo": "Col. Lomas de Sotelo",
    "estado": "MEX",
    "phone": 5553951768,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T097",
    "zipCode": 53390,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.4684426053398,
    "lng": -99.2264461055214,
    "id": 89
  },
  {
    "name": "PUEBLA, PARQUE PUEBLA",
    "ciudad": "PUEBLA",
    "municipio": "Puebla",
    "address": "Clza.Ignacio Zaragoza No.410",
    "addressTwo": "Col. Corredor Cienega",
    "estado": "PUE",
    "phone": 2222274731,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T098",
    "zipCode": 72220,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.0694616200256,
    "lng": -98.1724972911808,
    "id": 90
  },
  {
    "name": "CDMX, PARQUE LAS ANTENAS",
    "ciudad": "CDMX",
    "municipio": "Iztapalapa",
    "address": "Av.Periferico. 3278 L78-81",
    "addressTwo": "Col. La Esperanza",
    "estado": "CMX",
    "phone": 5550884239,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T099",
    "zipCode": 9910,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.314659131146,
    "lng": -99.0760014533927,
    "id": 91
  },
   {
     "name": "GUADALAJARA, MIDTOWN JALISCO",
     "ciudad": "GUADALAJARA",
     "municipio": "Guadalajara",
     "address": "Av. Lopez Mateos No. 2405",
     "addressTwo": "L-19 Col.Italia Providencia",
     "estado": "JAL",
     "phone": 7788996655,
     "website": "shasa.com",
     "email": "",
     "storeCode": "T100",
     "zipCode": 44648,
     "extra3": "",
     "tags": "[\"tienda\"]",
     "monday": "",
     "modayA": "",
     "mondayC": "",
     "tuesday": "",
     "tuesdayA": "",
     "tuesdayC": "",
     "wednesday": "",
     "wednesdayA": "",
     "wednsayC": "",
     "thursday": "",
     "thursdayA": "",
     "thursdayC": "",
     "friday": "",
     "fridayA": "",
     "fridayC": "",
     "saturday": "",
     "saturdayA": "",
     "saturdayC": "",
     "sunday": "",
     "sundayA": "",
     "sundayC": "",
     "lat": 20.69365968206383,
     "lng": -103.375328436197,
     "id": 92
   },
  {
    "name": "TUXTLA GTZ PLAZA AMBAR",
    "ciudad": "TUXTLA GTZ PLAZA AMBAR",
    "municipio": "Chiapas",
    "address": "Blvd.Salomon Gzlez Blanco 651",
    "addressTwo": "Col. El Retiro",
    "estado": "CHP",
    "phone": 9616141202,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T101",
    "zipCode": 29040,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 16.7454256028642,
    "lng": -93.0742587828241,
    "id": 93
  },
  {
    "name": "TAMPICO, ALTAMA CITY CENTER",
    "ciudad": "TAMPICO",
    "municipio": "Tamaulipas",
    "address": "Av.Ejercito Mexicano 706 L2007",
    "addressTwo": "Col. Primavera",
    "estado": "TAM",
    "phone": 8336883850,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T102",
    "zipCode": 89130,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 22.2492362988999,
    "lng": -97.8645313543255,
    "id": 94
  },
  {
    "name": "ZAMORA, SENTURA ZAMORA",
    "ciudad": "ZAMORA",
    "municipio": "ZAMORA",
    "address": "Carr. Zamora la Barca",
    "addressTwo": "Col. Atecuario Num. Ext 4300",
    "estado": "MIC",
    "phone": 7788991122,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T103",
    "zipCode": 59716,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.0268162098673,
    "lng": -102.276878708941,
    "id": 95
  },
  {
    "name": "FRESNILLO, PORTAL FRESNILLO",
    "ciudad": "FRESNILLO",
    "municipio": "Zacatecas",
    "address": "Av. Sonora Ext 1033 Int. SSA17",
    "addressTwo": "Col. Panamericana",
    "estado": "ZAC",
    "phone": 7865435265,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T104",
    "zipCode": 99014,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 23.1960911432713,
    "lng": -102.884314794467,
    "id": 96
  },
  {
    "name": "GUADALAJARA,GALERIAS STA ANITA",
    "ciudad": "GUADALAJARA",
    "municipio": "JAL",
    "address": "Av. Lopez Mateos Num.Ext. 9900",
    "addressTwo": "San Agustin",
    "estado": "JAL",
    "phone": 9988776655,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T105",
    "zipCode": 45645,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.5534597309267,
    "lng": -103.468492090482,
    "id": 97
  },
  {
    "name": "CDMX, ENCUENTRO OCEANIA",
    "ciudad": "CDMX",
    "municipio": "MEX",
    "address": "Av. Peñon Num 355 L- MA09",
    "addressTwo": "Col. Moctezuma 2DA Seccion",
    "estado": "CMX",
    "phone": "",
    "website": "shasa.com",
    "email": "",
    "storeCode": "T106",
    "zipCode": 15530,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.4395375525668,
    "lng": -99.0941419889544,
    "id": 98
  },
  {
    "name": "VALLE DE CHALCO, PATIO CHALCO",
    "ciudad": "VALLE DE CHALCO",
    "municipio": "Valle de Chalco",
    "address": "Blvd. Juan Pablo II Ext. 370",
    "addressTwo": "Col. El Agostadero",
    "estado": "CMX",
    "phone": "",
    "website": "shasa.com",
    "email": "",
    "storeCode": "T107",
    "zipCode": 56615,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.3002328495084,
    "lng": -98.9528096954523,
    "id": 99
  },
  {
    "name": "GUADALAJARA, DISTRITO LA PERLA",
    "ciudad": "GUADALAJARA",
    "municipio": "Zapopan",
    "address": "Av. Mariano Otero Ext. 3000",
    "addressTwo": "Int. B111 Col. Ciudad del Sol",
    "estado": "JAL",
    "phone": 6655443322,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T108",
    "zipCode": 45050,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.6447828182902,
    "lng": -103.412210220335,
    "id": 100
  },
  {
    "name": "MONTERREY,GALERIAS MONTERREY",
    "ciudad": "MONTERREY",
    "municipio": "Monterrey",
    "address": "AV. Insurgentes Ext. 2500",
    "addressTwo": "Int. 972 Col. Vista Hermosa",
    "estado": "NLE",
    "phone": 8877665577,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T109",
    "zipCode": 64620,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 25.6822225573808,
    "lng": -100.353665826597,
    "id": 101
  },
  {
    "name": "TAPACHULA, ALAIA TAPACHULA",
    "ciudad": "TAPACHULA",
    "municipio": "TAPACHULA",
    "address": "Carr. a Puerto Madero No. 177",
    "addressTwo": "Int. L41.42 Col. Tap. Centro",
    "estado": "CHP",
    "phone": 7755668844,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T110",
    "zipCode": 30700,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 14.8745167539777,
    "lng": -92.2830251417135,
    "id": 102
  },
  {
    "name": "GUANAJUATO, ALAIA GUANAJUATO",
    "ciudad": "GUANAJUATO",
    "municipio": "Guanajuato",
    "address": "Blvd. Euquerio Guerrero No.139",
    "addressTwo": "Yerbabuena",
    "estado": "GUA",
    "phone": 7678987987,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T111",
    "zipCode": 36259,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.9724783593386,
    "lng": -101.278765121327,
    "id": 103
  },
  {
    "name": "TIJUANA, PLAZA PENINSULA",
    "ciudad": "TIJUANA",
    "municipio": "TIJUANA",
    "address": "Av. Via Rapida Oriente No15000",
    "addressTwo": "Int. SA-01A Col. Chapultepec",
    "estado": "BCS",
    "phone": 8765456899,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T112",
    "zipCode": 22110,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 32.5135996773133,
    "lng": -116.965614645259,
    "id": 104
  },
  {
    "name": "CDMX, PARQUE TEPEYAC",
    "ciudad": "CDMX",
    "municipio": "Gustavo A. Madero",
    "address": "Av. Ing. Eduardo Molina #6730",
    "addressTwo": "Int.84-85 Col.Granjas Modernas",
    "estado": "CMX",
    "phone": "",
    "website": "shasa.com",
    "email": "",
    "storeCode": "T113",
    "zipCode": 7460,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.4758242563223,
    "lng": -99.1003425083863,
    "id": 105
  },
  {
    "name": "MONTERREY, PASEO LA FE",
    "ciudad": "MONTERREY",
    "municipio": "San Nicolás de los Garza",
    "address": "Av. Miguel Aleman #200",
    "addressTwo": "Int. A32 A33 Col. La Talaverna",
    "estado": "NLE",
    "phone": 9988776655,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T114",
    "zipCode": 66473,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 25.7199984336787,
    "lng": -100.219064116653,
    "id": 106
  },
  {
    "name": "SAN LUIS POTOSI, EL DORADO",
    "ciudad": "SAN LUIS POTOSI",
    "municipio": "SAN LUIS POTOSI",
    "address": "Av. Nereo Rdgz Barragan # 45",
    "addressTwo": "Int. L-9-12 Col. Del Valle",
    "estado": "SLP",
    "phone": 7890987667,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T115",
    "zipCode": 78200,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 22.1552408156349,
    "lng": -101.004787742325,
    "id": 107
  },
  {
    "name": "GUADALAJARA, PLAZA PATRIA",
    "ciudad": "GUADALAJARA",
    "municipio": "Zapopan",
    "address": "Avenida Patria SN",
    "addressTwo": "Numero Interior D7",
    "estado": "JAL",
    "phone": 9988776655,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T116",
    "zipCode": 45157,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.7123565354098,
    "lng": -103.378378473612,
    "id": 108
  },
  {
    "name": "COACALCO, COSMOPOL",
    "ciudad": "COACALCO",
    "municipio": "Coacalco de Berriozabal",
    "address": "Av. Jose Lopez Portillo 1 Int",
    "addressTwo": "E002-4 Col. San Fco. Coacalco",
    "estado": "CMX",
    "phone": 8877664433,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T117",
    "zipCode": 55712,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.6392030939853,
    "lng": -99.0890654012243,
    "id": 109
  },
  {
    "name": "CDMX, MITIKAH",
    "ciudad": "CDMX",
    "municipio": "BENITO JUAREZ",
    "address": "Av. Real Marorazco Num. 130",
    "addressTwo": "Int. 2N-35. Col. Xoco",
    "estado": "CMX",
    "phone": "",
    "website": "shasa.com",
    "email": "",
    "storeCode": "T118",
    "zipCode": 3330,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.3603218526801,
    "lng": -99.1679051662553,
    "id": 110
  },
  {
    "name": "ATLIXCO, MORALEDA",
    "ciudad": "ATLIXCO",
    "municipio": "ATLIXCO",
    "address": "Carr. Pue. Izucar de Matamoto",
    "addressTwo": "1901, Int. 128 -131",
    "estado": "PUE",
    "phone": 9988776655,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T119",
    "zipCode": 74294,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 18.8924661665041,
    "lng": -98.4260920508274,
    "id": 111
  },
  {
    "name": "COMITAN, PLAZA LAS FLORES",
    "ciudad": "COMITAN",
    "municipio": "COMITAN DE DOMINGUEZ",
    "address": "Blvd. De las Federaciones",
    "addressTwo": "KM 1260.50 Ext. 4021 Int. 6-9",
    "estado": "CHP",
    "phone": 8877556644,
    "website": "shasa.com",
    "email": "",
    "storeCode": "T120",
    "zipCode": 30093,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 16.2156138999574,
    "lng": -92.1297323825347,
    "id": 112
  },
  {
    "name": "PLAYA DEL CARMEN, QUINTA ALEGRIA",
    "ciudad": "PLAYA DEL CARMEN",
    "municipio": "Solidaridad",
    "address": "Av. Constituyentes No. 269",
    "addressTwo": "Col. Gonzalo Guerrero",
    "estado": "ROO",
    "phone": "",
    "website": "shasa.com",
    "email": "",
    "storeCode": "T122",
    "zipCode": 77720,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.6297796,
    "lng": -87.0703991,
    "id": 113
  },
  {
    "name": "LEON, PLAZA MAYOR",
    "ciudad": "LEON",
    "municipio": "León",
    "address": "Blvd. Juan Alonso de Torres SN",
    "addressTwo": "Col. Valle del Campestre",
    "estado": "GUA",
    "phone": "",
    "website": "shasa.com",
    "email": "",
    "storeCode": "T123",
    "zipCode": 37150,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 21.155856,
    "lng": -101.6951246,
    "id": 114
  },
  {
    "name": "GUADALAJARA, GRAN TERRAZA OBLATOS",
    "ciudad": "GUADALAJARA",
    "municipio": "Guadalajara",
    "address": "Av. Circunvalación Oblatos No. 2700",
    "addressTwo": "Col. Circunvalación Oblatos",
    "estado": "JAL",
    "phone": "",
    "website": "shasa.com",
    "email": "",
    "storeCode": "T126",
    "zipCode": 44716,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.6878534,
    "lng": -103.2958895,
    "id": 115
  },
  {
    "name": "POZA RICA, PLAZA CRYSTAL",
    "ciudad": "POZA RICA",
    "municipio": "Poza Rica de Hidalgo",
    "address": "Blvd. Lázaro Cárdenas No. 807",
    "addressTwo": "Col. Morelos",
    "estado": "VER",
    "phone": "",
    "website": "shasa.com",
    "email": "",
    "storeCode": "T127",
    "zipCode": 93340,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 20.535454,
    "lng": -97.4719747,
    "id": 116
  },
  {
    "name": "CAMPUS",
    "ciudad": "ESTADO DE MÉXICO",
    "municipio": "",
    "address": "Blvd Apto. Miguel Aleman 154",
    "addressTwo": "Col. Rancho el Rosario",
    "estado": "MEX",
    "phone": "",
    "website": "shasa.com",
    "email": "",
    "storeCode": "CAMPUS",
    "zipCode": 52000,
    "extra3": "",
    "tags": "[\"tienda\"]",
    "monday": "",
    "modayA": "",
    "mondayC": "",
    "tuesday": "",
    "tuesdayA": "",
    "tuesdayC": "",
    "wednesday": "",
    "wednesdayA": "",
    "wednsayC": "",
    "thursday": "",
    "thursdayA": "",
    "thursdayC": "",
    "friday": "",
    "fridayA": "",
    "fridayC": "",
    "saturday": "",
    "saturdayA": "",
    "saturdayC": "",
    "sunday": "",
    "sundayA": "",
    "sundayC": "",
    "lat": 19.3032113,
    "lng": -99.5572419,
    "id": 117
  }
];